import { Component, inject } from '@angular/core';
import { Navbar } from '../navbar/navbar';
import { Footer } from '../footer/footer';
import { RouterLink } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment.development';

@Component({
  selector: 'app-page-not-found',
  imports: [
    Navbar,
    Footer,
    RouterLink
  ],
  templateUrl: './page-not-found.html',
  styleUrl: './page-not-found.css',
})
export class PageNotFound {
  title = inject(Title);

  ngOnInit() : void {
    this.title.setTitle(`Page not found - ${environment.appName}`);
  }
}

